import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { computed, defineComponent, ref } from "vue"; // modules

import AuthModule from "@/store/modules/auth"; // components

import { isUserLoggedIn } from "@/utils/vue-helpers/user";
import CustomerSeatingChart from "@/views/Customer-Display/components/CustomerSeatingChart.vue";
import CustomerBasket from "@/views/Customer-Display/components/CustomerBasket.vue";
import { LogService } from "@/services/logging";
import { getCustomerBasketData } from "@/utils/vue-helpers/customer-display";
import POSConfigModule from "@/store/modules/pos-config";
export default defineComponent({
  name: "CustomerDisplay",
  components: {
    CustomerSeatingChart: CustomerSeatingChart,
    CustomerBasket: CustomerBasket
  },
  setup: function setup() {
    console.log("hi from setup of CustomerDisplay"); // creating a reference to the component CustomerSeatingChart
    // so that we can trigger CustomerSeatingChart.selectObjects() & CustomerSeatingChart.deselectObjects() functions

    var customerSeatingChart = ref(null); // so that we can trigger the component CustomerBasket to force re-render by increasing its key

    var customerBasket = ref(null);
    var componentBasketKey = ref(0);
    var basketData = ref(null);
    console.log("basketData");
    console.log(basketData);
    var renderCustomerSeatingChart = ref(false);
    var chartData = ref(null); // let customerBasketSetupFunction = ref<any>(setupAsideOrderSummary());

    var isAuth = computed(function () {
      return AuthModule.getIsAuth;
    });

    function addSelectedSeatsOnChart(newlySelectedSeats) {
      var _customerSeatingChart;

      (_customerSeatingChart = customerSeatingChart.value) === null || _customerSeatingChart === void 0 ? void 0 : _customerSeatingChart.selectObjects(newlySelectedSeats);
    }

    function removeSelectedSeatsOnChart(deselectedSeats) {
      var _customerSeatingChart2;

      (_customerSeatingChart2 = customerSeatingChart.value) === null || _customerSeatingChart2 === void 0 ? void 0 : _customerSeatingChart2.deselectObjects(deselectedSeats);
    }

    function forceBasketRerendering() {
      console.log("hi from forceBasketRerendering");
      componentBasketKey.value += 1; // Incrementing the key forces re-render of XXX
    }

    var pictureUrl = computed(function () {
      return POSConfigModule.configPictureUrl;
    });
    return {
      isUserLoggedIn: isUserLoggedIn,
      isAuth: isAuth,
      renderCustomerSeatingChart: renderCustomerSeatingChart,
      chartData: chartData,
      customerSeatingChart: customerSeatingChart,
      addSelectedSeatsOnChart: addSelectedSeatsOnChart,
      removeSelectedSeatsOnChart: removeSelectedSeatsOnChart,
      customerBasket: customerBasket,
      componentBasketKey: componentBasketKey,
      forceBasketRerendering: forceBasketRerendering,
      basketData: basketData,
      pictureUrl: pictureUrl
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("hi from beforeMount of customer-display");
              _context.next = 3;
              return getCustomerBasketData();

            case 3:
              _this.basketData = _context.sent;
              console.log("this.basketData");
              console.log(_this.basketData);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var broadcastChannel;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log("hi from mounted of customer-display"); // Assigning a value to the basketData when the customer display is mounted, it will be updated once user update the booking
              // Creating a broadcastChannel object linked to pos.smeetz

              broadcastChannel = new BroadcastChannel("pos.smeetz"); // listenning to the channel pos.smeetz

              broadcastChannel.onmessage = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
                  var receivedData;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          console.log("broadcastchannel onmessage of customer-display");
                          receivedData = JSON.parse(event.data);
                          console.log("receivedData");
                          console.log(receivedData);
                          LogService.info("Attached data received in broadcast channel", {
                            params: receivedData
                          });

                          if (receivedData.isChartToUpdate) {
                            _this2.renderCustomerSeatingChart = receivedData.renderCustomerSeatingChart;
                            _this2.closeChartInCustomerDisplay = receivedData.closeChartInCustomerDisplay;
                            _this2.chartData = receivedData.chartData;
                          }

                          if (receivedData.isBookingUpdated) {
                            // console.log("so booking was actually updated");
                            // Here we update CustomerBasket, and we may update a chart if already opened in case user selected/deseelcted seats
                            console.log("Booking is updated, we received basket data");
                            console.log("receivedData");
                            console.log(receivedData);
                            console.log("receivedData.customerBasketData");
                            console.log(receivedData.customerBasketData);

                            if (receivedData.customerBasketData) {
                              if (_this2.basketData) {
                                Object.assign(_this2.basketData, receivedData.customerBasketData);
                              } else {
                                _this2.basketData = receivedData.customerBasketData;
                              }
                            } else {
                              console.error("something is wrong");
                            } // 1- checking for newly selected seats


                            if (receivedData.newlySelectedSeats && receivedData.newlySelectedSeats.length) {
                              // So user has just selected new seats, lets select them in the already shown chart
                              // do it by triggering a function inside CustomerSeatingChart and passing newlySelectedSeats variable
                              _this2.addSelectedSeatsOnChart(receivedData.newlySelectedSeats);
                            } // 2- checking for newly deselected seats


                            if (receivedData.deselectedSeats && receivedData.deselectedSeats.length) {
                              // So user has just deselected seats, lets deselect them in the already shown chart
                              // do it by triggering a function inside CustomerSeatingChart and passing deselectedSeats variable
                              _this2.removeSelectedSeatsOnChart(receivedData.deselectedSeats);
                            }
                          }

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }();

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
});